import {
  Fab,
  FabProps
} from "@mui/material";
import { useRoute } from "hooks/useRoute";


export const SecureFab = (
  props: FabProps & { href: string, strictCheck?: boolean },
): JSX.Element => {
  const { isAvailable, navigate} = useRoute({path: props.href, strict: props.strictCheck});

  if (!isAvailable) {
    return <></>;
  }

  const newProps = { ...props, onClick: navigate, href: undefined };

  delete newProps.strictCheck;

  return <Fab {...newProps} />;
};